import axios from 'axios';

const baseURL = process.env.REACT_APP_SFTP_API_URL;
const authToken = process.env.REACT_APP_API_TOKEN;

const sftpApi = axios.create({
    baseURL: baseURL,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
        Authorization: authToken,
    },
});

export default sftpApi;
